/* eslint-disable no-mixed-spaces-and-tabs */
// import { datetimeCovertertolocal } from '../../datetime-converter';
import { datetimeCovertertolocal } from '../../datetime-converter';
import { TASK_LIST, TASK_LIST_SUCCESS, TASK_LIST_ERROR, TASK_LIST_DETAILS, TASK_LIST_DETAILS_SUCCESS, TASK_LIST_DETAILS_ERROR, USERS_LIST, USERS_LIST_SUCCESS, USERS_LIST_ERROR, REPORT_ALARM_DETAILS } from './constants';
import activityicons from '../../activitytypes';

export default function shiftdata(state, action) {
	
	
	let situation = [];
	let pagination = {};

	switch (action.type) {
      
	case TASK_LIST:
		return { ...state, pending: true };
                
	case TASK_LIST_SUCCESS:
                
		if (action.payload && action.payload.data && action.payload.data.data.length > 0) {
			if (action.payload) {
				pagination.total = action.payload.data.total ? action.payload.data.total : 0;
				pagination.limit = action.payload.data.limit ? action.payload.data.limit : 10;
				pagination.skip = action.payload.data.skip ? action.payload.data.skip : 0;
				pagination.current = action.page ? action.page : 1;
				pagination.pageSize =  action.pageSize ? action.pageSize : 10;
                    
			}
			action.payload.data.data && action.payload.data.data.map((item, index) => {
				activityicons && activityicons.map((eventactivity)=>{
					
					if(item.eventType==eventactivity.type){
						const datetime = datetimeCovertertolocal(item.datetime);
						const newdate = datetime.localdate + ' ' +  datetime.localtime;
						situation.push({
							key: index.toString(),
							alarm_prm_id: item?.alarm_prm_id,
							eventType: item?.eventType,
							description:item?.ruleDesc,
							date:newdate,
							// durations:item.duration ? (item.duration/60).toFixed(2) + ` ${langdata && langdata.Min ? langdata.Min:' Min'}` : 0 + ` ${langdata && langdata.Min ? langdata.Min:' Min'}`,
							channel: item?.channel_name,
							eventDate: newdate,
							chainage: item?.locationDetails ? item.locationDetails.info : null,
							odMeter: item?.odMeter,
							status:item?.status,
							pidsinfoId:item?.pidsinfoId,
							lat: item?.locationDetails ? item.locationDetails.Lat : null,
							long: item?.locationDetails ? item.locationDetails.Long : null,
							channel_name:item?.channel_name ? item.channel_name :'',
							alarmSeverity:item?.alarmSeverity ? item.alarmSeverity :'',
							eventprobablity : item?.eventConfidence ? item.eventConfidence :'',
							remarks:item?.remarks? item.remarks :'',
							locationDetails:item?.locationDetails,
							regioninfoId:item?.regioninfoId,
							pipelineId:item?.pipelineId,
							ackdetDetails:item?.ackdetDetails,
							datetime:item?.datetime,
							duration:item?.duration,
							isparent: item?.isParent ? 'Primary' : 'Related',
							gps:`Latitude: ${item.locationDetails.Lat} Longitude: ${item.locationDetails.Long}`,
							showGPS:`Latitude: ${item.locationDetails.Lat.toFixed(5)} Longitude: ${item.locationDetails.Long.toFixed(5)}`,
							pidsname:item.pids_name.toUpperCase(),
							// region : regiondata && regiondata.map((region) => { if (item.regioninfoId === region.id){ return region.regionName.toUpperCase();} }),
							activityUrl: eventactivity.type && item.eventType==eventactivity.type ? eventactivity.severity[item.alarmSeverity] : '-',
							channelId:item.channelId,
							regionName : item && item?.regionName ? item.regionName : 'No Data',
							pids_name : item && item?.pids_name ? item.pids_name : 'No Data',
							pipelineChainage : item?.pipelineChainage,
							id : item?.alarm_prm_id,
							userName :  item?.firstName ? item.firstName + ' ' + item.lastName : 'No Data'
							// alarmSeverity : item.eventConfidence
							// channel_name : item.channel_name

						});
					}
				});
			});
    
			
        
			return { ...state, situation: situation, pending: false, error: false , pagination: pagination  };
		} else {			
                
			if (action.payload && action.payload.data.length == 0) {
                        
				return { ...state, situation: [], pending: false, error: false };
			} else {
    
				return { ...state, situation: [] , pending: false, error: true };
			}
		}
                
	case TASK_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case TASK_LIST_DETAILS:
		return { ...state, pending: true };
        
	case TASK_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, details:action.payload, error: false };
	case TASK_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };

	case REPORT_ALARM_DETAILS:
		return { ...state, details: action.payload, error: true };
      
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}